import { resolveCapability } from "./resolve";
import { CAPABILITIES } from "./registry";
import type { Capability, ResolveContext } from "./types";

/**
 * A member-portal capability is reachable iff it resolves available AND the
 * registry doesn't explicitly hide it from the portal (portal.visible === false).
 * Single source of truth shared by the member nav filter and the member route gate.
 */
export function isPortalVisible(
  capability: string,
  ctx: ResolveContext,
  registry: Record<string, Capability> = CAPABILITIES,
): boolean {
  return (
    resolveCapability(capability, ctx, registry).available &&
    registry[capability]?.portal?.visible !== false
  );
}
